export default "__VITE_ASSET__Dhvy6rmF__"